import React from 'react'
import PropTypes from 'prop-types'
import Dialog from 'components/dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogActions from '@material-ui/core/DialogActions'
import Button from '@material-ui/core/Button'
import FileDownloadOutlinedIcon from 'components/material-symbol/icons/FileDownload'
import { CSVLink } from 'react-csv'

const ExportTransactionsDialog = ({
  open,
  onClose,
  filename,
  csvData,
  monthLabel,
}) => {
  return (
    <Dialog
      isOpen={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      showCloseButton
    >
      {({ closeDialog }) => (
        <>
          <DialogTitle>Export transactions</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Download a CSV of your transactions for {monthLabel}. The file
              will save to your device automatically.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={closeDialog}>Cancel</Button>
            <Button
              component={CSVLink}
              variant="contained"
              color="primary"
              startIcon={<FileDownloadOutlinedIcon />}
              filename={filename}
              data={csvData}
              onClick={closeDialog}
            >
              Download CSV
            </Button>
          </DialogActions>
        </>
      )}
    </Dialog>
  )
}

ExportTransactionsDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  filename: PropTypes.string.isRequired,
  csvData: PropTypes.arrayOf(PropTypes.object).isRequired,
  monthLabel: PropTypes.string.isRequired,
}

export default ExportTransactionsDialog
